<template>
  <v-app-bar app>
    <router-link to="/">
      <img
        class="logo"
        :src="require('../../public/icons/Blueberry_logo.svg')"
        alt="Logo"
      />
    </router-link>
    <v-spacer />
    <div class="d-flex align-center mr-3" v-if="onPhone">
      <span class="h3 font-weight-bold green--text">ON THE CALL</span>
      <v-btn class="ml-2" @click="moveToTheLead">OPEN LEAD</v-btn>
    </div>
    <!-- <v-switch
      v-if="isAuth && user.role_id === 2"
      v-model="swithInboundOnline"
      flat
      color="success ml-3"
      hide-details
      :label="'3rd Party Call'"
    /> -->
    <NotificationsList
      v-if="isAuth"
      class="mr-2"
      :notifications="notifications"
    />
    <v-switch
      v-if="isAuth && user.role_id === 2"
      v-model="switchOnline"
      flat
      color="success ml-3"
      hide-details
      :label="this.online ? 'Online' : 'Offline'"
    />
    <Settings class="ml-2" />
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Settings from "@/components/menus/Settings.vue";
import NotificationsList from "@/components/messages/NotificationsList";

export default {
  name: "Navbar",
  components: {
    NotificationsList,
    Settings,
  },
  methods: {
    ...mapActions({
      // setOnline: "auth/setOnline",
      // setOffline: "auth/setOffline"
      twilioTokenHandler: "auth/twilioTokenHandler",
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
      loadNotifications: "notifications/loadNotifications",
    }),
    ...mapMutations({
      setOnlineStatus: "auth/SET_ONLINE_STATUS",
      UPDATE_MESSAGE_NOTIFICATION: "notifications/UPDATE_MESSAGE_NOTIFICATION",
      UPDATE_VOICEMAILS_NOTIFICATION:
        "notifications/UPDATE_VOICEMAILS_NOTIFICATION",
    }),
    moveToTheLead() {
      this.$router.replace("/lead/" + this.leadId);
    },
    handleStatus(field, status) {
      this.$axios
        .post("/user/change-status", {
          user_id: this.user.id,
          field: field,
          status: status,
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    if (this.user.role_id == 2) {
      window.addEventListener("beforeunload", (event) => {
        // Cancel the event as stated by the standard.
        event.preventDefault();
        this.setOnlineStatus(false);
        this.handleStatus("online", 0);
        this.handleStatus("in_call", 0);

        // Chrome requires returnValue to be set.
        event.returnValue = "";
      });
    }

    this.sockets.subscribe("FOLLOWUP_NOTIFICATION", (item) => {
      this.showHandlerSnackbar({
        color: "orange",
        text: item,
        show: true,
      });
    });
    this.loadNotifications(this.user.id);

    this.sockets.subscribe("ADD_LEAD_ID", (data) => {
      setTimeout(() => {
        this.$router.replace("/lead/" + data);
      }, 5000);
      // if (this.online) {
      //   this.twilioTokenHandler(this.user.id);
      // }
    });

    this.sockets.subscribe("RECEIVE_MESSAGE", (notification) => {
      this.showHandlerSnackbar({
        color: "success",
        text:
          notification.lead_name +
          " just left you a new message. Please check it as soon as possible.",
        show: true,
      });

      this.notifications.unshift(notification);
    });

    this.sockets.subscribe("NOTIFICATION_UPDATES", (data) => {
      if (data.type === "message") {
        this.UPDATE_MESSAGE_NOTIFICATION(data.id);
      } else {
        this.UPDATE_VOICEMAILS_NOTIFICATION(data.id);
      }
    });

    this.sockets.subscribe("CREATE_CUSTOMER_VOICE_MAIL", (notification) => {
      if (notification.user_id === this.user.id || this.user.role_id === 1) {
        this.showHandlerSnackbar({
          color: "success",
          text:
            notification.lead_name +
            " just left you a new voicemail. Please check it as soon as possible.",
          show: true,
        });

        this.notifications.unshift(notification);
      }
    });

    if (this.online) {
      this.twilioTokenHandler(this.user.id);
    }
  },
  computed: {
    ...mapGetters({
      onPhone: "coldCall/onPhone",
      leadId: "coldCall/leadId",
      isAuth: "auth/isAuth",
      user: "auth/user",
      lead: "lead/lead",
      online: "auth/online",
      notifications: "notifications/notifications",
    }),
    switchOnline: {
      get() {
        return this.online;
      },
      set() {
        let user_id = this.user.id;
        let status = !this.online;

        this.setOnlineStatus(status);
        if (status) {
          this.twilioTokenHandler(user_id);
        }
        this.$socket.emit("set_online_status", {
          id: user_id,
          status: status,
        });
      },
    },
  },
  // mounted() {
  //   if (this.online) {
  //     this.twilioTokenHandler(this.user.id);
  //   }
  // },
};
</script>

<style lang="scss">
.logo {
  width: 200px;
}
</style>
